var render = function () {
  var _vm$labAccount, _vm$labAccount2, _vm$labAccount$labdat;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "xfill-height",
    attrs: {
      "xv-if": "LOGGED_IN && false",
      "id": "page"
    }
  }, [_c('v-overlay', {
    attrs: {
      "value": _vm.loading
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64"
    }
  })], 1), !_vm.loading && false ? _c('v-row', [_c('v-col', {
    staticClass: "col-lg-3 col-md-4 col-sm-6"
  }, [_c('v-card', {
    staticClass: "mx-auto fill-height d-flex flex-column rounded-xl"
  }, [_c('v-img', {
    staticClass: "align-end text-white flex-grow-0 mx-14",
    attrs: {
      "height": "200",
      "src": _vm.labImage,
      "contain": ""
    }
  }), _c('v-card-title', [_vm._v(_vm._s(_vm.labAccount.business))]), _c('v-card-text', [_vm._v(" Contact us if you have any questions or would like assistance. ")]), _c('v-card-actions', {
    staticClass: "mt-auto"
  }, [_c('router-link', {
    attrs: {
      "to": "./orders"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("Contact")])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "col-lg-3 col-md-4 col-sm-6"
  }, [_c('v-card', {
    staticClass: "mx-auto fill-height d-flex flex-column rounded-xl"
  }, [_c('v-img', {
    staticClass: "align-end text-white flex-grow-0",
    attrs: {
      "height": "200",
      "src": _vm.assets.img_work,
      "cover": ""
    }
  }), _c('v-card-title', [_vm._v("My Orders")]), _c('v-card-text', [_vm._v(" Stay in the loop as we we manufacture your orders. ")]), _c('v-card-actions', {
    staticClass: "mt-auto"
  }, [_c('router-link', {
    attrs: {
      "to": "./orders"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("View Orders")])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "col-lg-3 col-md-4 col-sm-6"
  }, [_c('v-card', {
    staticClass: "mx-auto fill-height d-flex flex-column rounded-xl"
  }, [_c('v-img', {
    staticClass: "align-end text-white flex-grow-0",
    attrs: {
      "height": "200",
      "src": _vm.assets.img_download,
      "cover": ""
    }
  }), _c('v-card-title', [_vm._v("LaserCAM Software")]), _c('v-card-text', [_vm._v(" Download our software to prescribe, design, and manufacture custom orthotic devices. ")]), _c('v-card-actions', {
    staticClass: "mt-auto"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("Download")])], 1)], 1)], 1), _c('v-col', {
    staticClass: "col-lg-3 col-md-4 col-sm-6"
  }, [_c('v-card', {
    staticClass: "mx-auto fill-height d-flex flex-column rounded-xl"
  }, [_c('v-img', {
    staticClass: "align-end text-white flex-grow-0",
    attrs: {
      "height": "200",
      "src": _vm.assets.img_book,
      "cover": ""
    }
  }), _c('v-card-title', [_vm._v("Prescription Guides")]), _c('v-card-text', [_vm._v(" See our guide for details on all prescription options that are available within LaserCAM Prescribe, and more. ")]), _c('v-card-actions', {
    staticClass: "mt-auto"
  }, [_c('a', {
    attrs: {
      "href": "https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/688249/Machined+EVA",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("Open Guide")])], 1)])], 1)], 1)], 1) : _vm._e(), _c('v-row', {}, [_c('v-col', [_c('v-card', {
    staticClass: "rounded-lg mx-auto",
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-content', [_c('v-img', {
    staticClass: "align-end text-white flex-grow-0 mx-auto my-6",
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "src": _vm.labImage,
      "contain": ""
    }
  })], 1)], 1), _c('v-divider'), (_vm$labAccount = _vm.labAccount) !== null && _vm$labAccount !== void 0 && _vm$labAccount.contact_email ? [_c('v-list-item', {
    attrs: {
      "href": "mailto:".concat(_vm.labAccount.contact_email)
    }
  }, [_c('v-list-item-icon', {
    staticClass: "primary pa-3 rounded-lg grad-45"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-h6"
  }, [_vm._v("Email " + _vm._s(_vm.labAccount.business))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.labAccount.contact_email))])], 1)], 1), _c('v-divider')] : _vm._e(), (_vm$labAccount2 = _vm.labAccount) !== null && _vm$labAccount2 !== void 0 && _vm$labAccount2.contact_phone ? [_c('v-list-item', {
    attrs: {
      "href": "tel:".concat(_vm.labAccount.contact_phone)
    }
  }, [_c('v-list-item-icon', {
    staticClass: "primary pa-3 rounded-lg grad-45"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-h6"
  }, [_vm._v("Call " + _vm._s(_vm.labAccount.business))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.labAccount.contact_phone))])], 1)], 1), _c('v-divider')] : _vm._e(), _c('v-list-item', {
    attrs: {
      "to": "./orders"
    }
  }, [_c('v-list-item-icon', {
    staticClass: "primary pa-3 rounded-lg grad-45"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("mdi-briefcase")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-h6"
  }, [_vm._v("My Orders")]), _c('v-list-item-subtitle', [_vm._v("Track the progress of your orders.")])], 1)], 1), _c('v-divider'), _vm.lasercam_setup_url ? [_c('v-list-item', {
    attrs: {
      "href": _vm.lasercam_setup_url,
      "three-line": ""
    }
  }, [_c('v-list-item-icon', {
    staticClass: "primary pa-3 rounded-lg grad-45"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("mdi-download")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-h6"
  }, [_vm._v("Download Software")]), _c('v-list-item-subtitle', [_vm._v("Install the LaserCAM software for Windows PC.")]), _c('v-list-item-subtitle', {
    staticClass: "text-subtitle-2"
  }, [_c('a', {
    attrs: {
      "href": "https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/163053575/SOP+Lab+Configuration#Update-LaserCAM-Lab-Code",
      "target": "_blank"
    }
  }, [_vm._v("Prescribe Labcode: " + _vm._s((_vm$labAccount$labdat = _vm.labAccount.labdata) === null || _vm$labAccount$labdat === void 0 ? void 0 : _vm$labAccount$labdat.labcode))])])], 1)], 1), _c('v-divider')] : _vm._e(), _c('v-list-item', {
    attrs: {
      "href": "https://lasercamkb.atlassian.net/wiki/spaces/LOK/pages/688249/Machined+EVA",
      "target": "_blank"
    }
  }, [_c('v-list-item-icon', {
    staticClass: "primary pa-3 rounded-lg grad-45"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("mdi-book-open-variant")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-h6"
  }, [_vm._v("Prescription Guides")]), _c('v-list-item-subtitle', [_vm._v("See our detailed guide for all prescription options available.")])], 1)], 1)], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }